import { useCallback } from "react"
import { useDispatch } from "react-redux"
import { useEvent } from "@hooks/useEvent"

export const useContainer = ({ containerKey, listKey, tableName, addData, updateData, deleteData }) => {
    const { isLoading, saveForm, deleteForm } = useEvent(containerKey)
    const dispatch = useDispatch();
    const addItem = useCallback(async (listId, otherParams) => {
        try {
            const response = await saveForm({
                [listKey]: [{ id: listId || '', [tableName]: [otherParams || {}] }]
            })
            if (response) {
                dispatch(addData({
                    data: response,
                    meta: { tableName }
                }))
                callback && callback(response)
            }
        } catch (e) {

        }

    }, []);


    const updateItem = useCallback((listId, id, data) => {
        dispatch(updateData({ listId, id, data, meta: { tableName } }))
    }, [])

    const saveItem = useCallback(async (listId, data) => {
        try {
            const response = await saveForm({
                [listKey]: [{ id: listId || '', [tableName]: [data] }]
            }, false)
        } catch {

        }
    }, [saveForm]);


    const deleteItem = useCallback(async (listId, id) => {
        try {
            const response = await deleteForm({
                [listKey]: [{ id: listId || '', [tableName]: [{ id: id }] }]
            })
            if (response) dispatch(deleteData({ listId, id, meta: { tableName } }))

        } catch (e) {

        }
    }, []);

    return { isLoading, addItem, updateItem, saveItem, deleteItem }
}